"use client"

import { Typography } from "antd";
import { TextProps } from "antd/es/typography/Text";
import { FC } from "react";

const Text: FC<TextProps> = (props) => {
  return (
    <Typography.Text {...props} />
  )
}

Text.displayName = 'Text'

export default Text